import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { InstanceMonitoringService } from '../../../services/instance-monitoring.service';
import { Instance, InstanceMonitoringData } from '../../../models';
import { InstanceService } from '../../../services';
import { Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-instance-monitoring',
    templateUrl: './instance-monitoring-table.component.html',
    styleUrls: ['./instance-monitoring-table.component.scss', '../../../../../shared/styles/mdl-table.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InstanceMonitoringTableComponent implements OnInit, OnDestroy {
    instanceMonitoringData: InstanceMonitoringData;
    subscriptions: Subscription[] = [];
    isLoaded: boolean = false;
    instance: Instance;
    constructor(
        private readonly instanceMonitoringService: InstanceMonitoringService,
        private readonly instanceService: InstanceService
    ) {}

    async ngOnInit() {
        this.subscriptions.push(
            this.instanceService.currentInstance
                .pipe(
                    filter(instance => instance !== null),
                    switchMap(instance => {
                        this.isLoaded = false;
                        this.instance = instance;
                        return this.instanceMonitoringService.getInstanceMonitoringData(instance);
                    })
                )
                .subscribe(instanceMonitoringData => {
                    this.instanceMonitoringData = instanceMonitoringData;
                    this.isLoaded = true;
                })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    async fixHappened() {
        this.isLoaded = false;
        this.instanceMonitoringData = await this.instanceMonitoringService
            .getInstanceMonitoringData(this.instanceService.currentInstanceSubject.value)
            .toPromise();
        this.isLoaded = true;
    }
}
